import { Form, Input } from "antd";
import { FormattedMessage } from "react-intl";

const { Item } = Form;

export const nationalIdPattern =
  "^\\d{2}(0[1-9]|1[0-2]|5[1-9]|6[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])/\\d{3,4}$";

const InputItem = ({
  validatorFunction,
  allowClear = true,
  formItemLayout,
  variableSymbol,
  czechCompanyId,
  onValueChange,
  autoComplete,
  initialValue,
  phoneNumber,
  placeholder,
  addonBefore,
  licenceIso,
  licenceGs1,
  addonAfter,
  wrapperCol,
  nationalId,
  fieldName,
  companyId,
  maxLength,
  minLength,
  autoFocus,
  disabled,
  onChange,
  password,
  labelCol,
  required,
  optional,
  message,
  zipCode,
  pattern,
  number,
  hidden,
  suffix,
  unCode,
  onBlur,
  error,
  label,
  email,
}) => (
  <Item
    help={error}
    label={label}
    hidden={hidden}
    name={fieldName}
    initialValue={initialValue}
    getValueFromEvent={onValueChange}
    validateStatus={error ? "error" : null}
    labelCol={
      labelCol ? { span: labelCol } : formItemLayout && formItemLayout.labelCol
    }
    wrapperCol={
      wrapperCol
        ? { span: wrapperCol }
        : formItemLayout && formItemLayout.wrapperCol
    }
    rules={[
      {
        required: (required || message) && !optional,
        message: required ? (
          <FormattedMessage
            id="messages.input.required"
            defaultMessage="Tento údaj je povinný!"
          />
        ) : (
          message
        ),
      },
      validatorFunction
        ? {
            validator: validatorFunction,
          }
        : {},
      email
        ? {
            type: "email",
            message: (
              <FormattedMessage
                id="messages.input.email"
                defaultMessage="Zadejte prosím validní email!"
              />
            ),
          }
        : {},
      variableSymbol
        ? {
            pattern: "^\\d{0,10}$",
            message: (
              <FormattedMessage
                id="messages.input.variableSymbol"
                defaultMessage="Variabilní symbol musí obsahovat pouze čísla a mít maximální délku 10!"
              />
            ),
          }
        : unCode
        ? {
            pattern: "^\\d{4}$",
            message: (
              <FormattedMessage
                id="messages.input.unCode"
                defaultMessage="UN kód musí obsahovat pouze čísla a být o délce 4!"
              />
            ),
          }
        : czechCompanyId && nationalId
        ? {
            pattern:
              "^(\\w{0,2}\\d{3,12})|(\\d{2}(0[1-9]|1[0-2]|5[1-9]|6[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])/\\d{3,4})$",
            message: (
              <FormattedMessage
                id="messages.input.companyIdOrNationalId"
                defaultMessage="Zadejte korektní IČO nebo rodné číslo!"
              />
            ),
          }
        : companyId
        ? {
            pattern: czechCompanyId ? "^\\w{0,2}\\d{3,12}$" : "^\\w{3,18}$",
            message: czechCompanyId ? (
              <FormattedMessage
                id="messages.input.companyId.czech"
                defaultMessage="IČO musí obsahovat pouze čísla a mít maximální délku 12!"
              />
            ) : (
              <FormattedMessage
                id="messages.input.companyId"
                defaultMessage="IČO musí mít maximální délku 18!"
              />
            ),
          }
        : nationalId
        ? {
            pattern: nationalIdPattern,
            message: (
              <FormattedMessage
                id="messages.input.nationalId"
                defaultMessage="Rodné číslo není ve správném formátu!"
              />
            ),
          }
        : licenceIso
        ? {
            pattern: "^[1-8]?J[A-Z]{2,3}[A-Z0-9]{1,35}$",
            message: (
              <FormattedMessage
                id="messages.input.licenceIso"
                defaultMessage="Zadejte prefix v korektním formátu!"
              />
            ),
          }
        : licenceGs1
        ? {
            pattern: "^00\\d{1,18}$",
            message: (
              <FormattedMessage
                id="messages.input.licenceGs1"
                defaultMessage="Zadejte prefix v korektním formátu!"
              />
            ),
          }
        : zipCode
        ? {
            pattern: "^\\d{5}$",
            message: (
              <FormattedMessage
                id="messages.input.zipCode"
                defaultMessage="Zadejte PSČ v pětimístném formátu!"
              />
            ),
          }
        : number
        ? {
            pattern: "^\\d+$",
            message: (
              <FormattedMessage
                id="messages.input.number"
                defaultMessage="Zadejte korektní číslo!"
              />
            ),
          }
        : phoneNumber
        ? {
            pattern: "^\\+?\\d{6,15}$",
            message: (
              <FormattedMessage
                id="messages.input.phoneNumber"
                defaultMessage="Zadejte korektní telefonní číslo!"
              />
            ),
          }
        : pattern
        ? pattern
        : {},
    ]}
  >
    {password ? (
      <Input.Password
        placeholder={placeholder}
        autoComplete={autoComplete || "off"}
      />
    ) : (
      <Input
        suffix={suffix}
        onBlur={onBlur}
        onChange={onChange}
        disabled={disabled}
        autoFocus={autoFocus}
        maxLength={maxLength}
        minLength={minLength}
        allowClear={allowClear}
        addonAfter={addonAfter}
        addonBefore={addonBefore}
        placeholder={placeholder}
        type={hidden ? "hidden" : "text"}
        autoComplete={autoComplete || "off"}
      />
    )}
  </Item>
);

export default InputItem;
